import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/notificacion/importer/notificacionImporterActions';

export default importerReducers(actions);
